import IC_BACK_TRACK from "@/assets/summary/back_track.svg?react";
import Tooltip from "@/component/Tooltip";
import summaryCommonStore from "@/store/summaryCommon.store";
import { BackTraceType } from "@/types/summary";
import "./index.less";

interface IProps {
  module: BackTraceType;
  index: number;
  item: string;
  className?: string;
}
const BackTraceItem: React.FC<IProps> = ({ module, index, item, className }) => {
  const showBackTraceEnter = summaryCommonStore(
    (state) => state.showBackTraceEnter
  );
  const backTraceData = summaryCommonStore((state) => state.backTraceData);
  const activeBackTraceKey = summaryCommonStore(
    (state) => state.activeBackTraceKey
  );

  const currentKey = `${module}-${index}`;

  const disabledBackTrace =
    !backTraceData ||
    !backTraceData[module] ||
    !backTraceData[module][index]?.length;

  const handleBackTrack = (
    searchValue: string,
    index: number,
    disabledBackTrace: boolean
  ) => {
    if (!showBackTraceEnter || disabledBackTrace) return;
    summaryCommonStore.getState().setActiveBackTraceKey(currentKey);
    // 打开回溯搜索框
    summaryCommonStore
      .getState()
      .updateBackTraceSearch(module, searchValue, index);
  };

  return (
    showBackTraceEnter &&
    !disabledBackTrace && (
      <Tooltip content="回溯原文" hover={true}>
        <IC_BACK_TRACK
          className={`${
            activeBackTraceKey === currentKey && "active"
          } ${className} back_track_icon cursor-pointer min-w-4.5`}
          onClick={() => handleBackTrack(item, index, disabledBackTrace)}
        />
      </Tooltip>
    )
  );
};

export default BackTraceItem;
